import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useRef, useMemo } from "react";
import { Tooltip, Menu, Typography } from "@mui/material";
import { CallActive } from "../../../../assets/icons/CallActive.js";
import { CallFinished } from "../../../../assets/icons/CallFinished.js";
import { CallIgnored } from "../../../../assets/icons/CallIgnored.js";
import { CallInProgress } from "../../../../assets/icons/CallInProgress.js";
import { CallOpen } from "../../../../assets/icons/CallOpen.js";
import { CallRinging } from "../../../../assets/icons/CallRinging.js";
import { CallTaskState, CallTaskActionType } from "../../../../call-management.types.js";
import { CallCardIgnoreForm } from "../CallCardIgnoreForm/CallCardIgnoreForm.js";
import { CallCardVoicemail } from "../CallCardVoicemail/CallCardVoicemail.js";
import { StatusButton, StatusWrapper, StyledInfoIcon, StyledMenuItem, StatusMenuIcon } from "./CallCardStatus.styles.js";
import "../CallCardIgnoreForm/CallCardIgnoreForm.helpers.js";
import "react-hook-form";
import "@hookform/resolvers/yup";
import "yup";
import "../CallCardIgnoreForm/CallCardIgnoreForm.styles.js";
import "@mui/material/styles";
import "../../../../assets/icons/Voicemail.js";
import "../../../../call-management.constants.js";
import "date-fns";
import "../CallCardName/CallCardName.styles.js";
import "../CallCardVoicemail/CallCardVoicemail.styles.js";
import "../../../../assets/icons/Info.js";
const CallCardStatus = ({
  status,
  isActive,
  phones,
  onIgnore,
  comment,
  isOpen,
  hasVoicemail,
  onVoicemailSelect,
  onSelect,
  labels
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showIgnoreForm, setShowIgnoreForm] = useState(false);
  const buttonRef = useRef(null);
  const showActions = isOpen && !isActive;
  const StartIcon = useMemo(() => {
    if (isOpen)
      return CallOpen;
    switch (status) {
      case CallTaskState.Open_Ringing:
        return CallRinging;
      case CallTaskState.Ignored:
        return CallIgnored;
      case CallTaskState.Done:
      case CallTaskState.Done_AvailyBooking:
        return CallFinished;
      case CallTaskState.Open_InProgress:
        return CallInProgress;
      default:
        return CallRinging;
    }
  }, [isActive, status]);
  const handleButtonClick = (event) => {
    event.stopPropagation();
    setAnchorEl((prevState) => prevState ? null : event.currentTarget);
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
    setShowIgnoreForm(false);
  };
  const handleCloseIgnoreForm = (event) => {
    event.stopPropagation();
    setShowIgnoreForm(false);
  };
  const handleMenuItemClick = (value) => (event) => {
    event.stopPropagation();
    if (typeof value !== "string") {
      onSelect(value);
    } else {
      setShowIgnoreForm(true);
    }
    setAnchorEl(null);
  };
  const handleIgnoreSubmit = async (data) => {
    await onIgnore(data);
    setShowIgnoreForm(false);
  };
  if (isActive) {
    return /* @__PURE__ */ jsx(StatusButton, { isActiveCall: true, disabled: true, disableRipple: true, startIcon: /* @__PURE__ */ jsx(CallActive, { fontSize: "inherit" }), children: labels.statusCalling });
  }
  return /* @__PURE__ */ jsxs(StatusWrapper, { children: [
    /* @__PURE__ */ jsx(
      StatusButton,
      {
        disabled: !showActions,
        disableRipple: true,
        isCallOpen: isOpen,
        startIcon: /* @__PURE__ */ jsx(StartIcon, { fontSize: "inherit" }),
        onClick: handleButtonClick,
        status,
        ref: buttonRef,
        children: labels.statusLabel[status]
      }
    ),
    !!comment && /* @__PURE__ */ jsx(Tooltip, { title: comment, children: /* @__PURE__ */ jsx(StyledInfoIcon, {}) }),
    /* @__PURE__ */ jsxs(
      Menu,
      {
        id: "more-actions",
        "data-testid": "call-dropdown",
        anchorEl,
        open: !!anchorEl,
        keepMounted: true,
        onClose: handleClose,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        children: [
          phones == null ? void 0 : phones.filter((phone) => phone).map((phone) => /* @__PURE__ */ jsxs(StyledMenuItem, { disableRipple: true, onClick: handleMenuItemClick(phone), children: [
            /* @__PURE__ */ jsx(StatusMenuIcon, { children: /* @__PURE__ */ jsx(CallOpen, {}) }),
            /* @__PURE__ */ jsx(Typography, { variant: "Lato Body 1", children: phone.name })
          ] }, phone.referenceId)),
          /* @__PURE__ */ jsxs(
            StyledMenuItem,
            {
              disableRipple: true,
              title: labels.ignoreCall,
              onClick: handleMenuItemClick(CallTaskActionType.Ignore),
              children: [
                /* @__PURE__ */ jsx(StatusMenuIcon, { isIgnore: true, children: /* @__PURE__ */ jsx(CallIgnored, {}) }),
                /* @__PURE__ */ jsx(Typography, { variant: "Lato Body 1", children: labels.ignoreCall })
              ]
            }
          )
        ]
      }
    ),
    hasVoicemail && !!(phones == null ? void 0 : phones.length) && /* @__PURE__ */ jsx(CallCardVoicemail, { status, phones, onSelect: onVoicemailSelect }),
    /* @__PURE__ */ jsx(
      CallCardIgnoreForm,
      {
        buttonRef: buttonRef.current,
        isOpen: showIgnoreForm,
        onClose: handleCloseIgnoreForm,
        onSubmit: handleIgnoreSubmit,
        labels: labels.ignoreForm
      }
    )
  ] });
};
export {
  CallCardStatus
};
